import React from 'react';
import { Link } from 'react-router-dom';
import TWLogo from '../../assets/TW-Rental.svg';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Header Section */}
      <div className="about-header">
        <div className="logo">
          <img src={TWLogo} alt="TW Rental Logo" className="logo-svg" />
        </div>
        
        <div className="navigation">
          <Link to="/home" className="nav-button">Home</Link>
          <button className="nav-button active">About Us</button>
          <Link to="/contact" className="nav-button">Contact Us</Link>
        </div>
      </div>
      
      {/* Main Content Section */}
      <div className="about-content">
        <div className="about-hero">
          <h1 className="about-title">About User Automation</h1>
          <p className="about-subtitle">Streamlining workflows and boosting productivity through intelligent automation solutions</p>
        </div>
        
        <div className="about-sections">
          <div className="about-section">
            <h2>Our Mission</h2>
            <p>We are dedicated to revolutionizing how businesses operate by providing cutting-edge automation solutions that eliminate repetitive tasks, reduce errors, and maximize efficiency. Our platform empowers organizations to focus on what matters most while we handle the rest.</p>
          </div>
          
          <div className="about-section">
            <h2>What We Do</h2>
            <p>User Automation offers a comprehensive suite of tools designed to integrate seamlessly with your existing workflows. From data processing and analysis to automated notifications and reporting, we provide the infrastructure you need to scale your operations without scaling your workload.</p>
          </div>
          
          <div className="about-section">
            <h2>Why Choose Us</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <h3>Lightning Fast</h3>
                <p>Process thousands of tasks in seconds, not hours</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔒</div>
                <h3>Secure & Reliable</h3>
                <p>Enterprise-grade security with 99.9% uptime</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎯</div>
                <h3>Precision</h3>
                <p>Eliminate human error with intelligent automation</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📈</div>
                <h3>Scalable</h3>
                <p>Grows with your business, from startup to enterprise</p>
              </div>
            </div>
          </div>
          
          <div className="about-section">
            <h2>Our Story</h2>
            <p>Founded in 2021, User Automation began as a vision to transform how businesses handle routine operations. What started as a small team of automation enthusiasts has grown into a comprehensive platform trusted by companies worldwide. We believe that technology should work for you, not against you, and our solutions reflect that philosophy.</p>
          </div>
        </div>
      </div>
      
      {/* Footer Section */}
      <div className="about-footer">
        <div className="copyright">© 2024. All Rights Reserved.</div>
        <div className="social-icons">
          <span className="social-icon">f</span>
          <span className="social-icon">📷</span>
          <span className="social-icon">in</span>
        </div>
      </div>
    </div>
  );
};

export default About;
